import React from 'react';
import PropTypes from 'prop-types';
import BodySpecialAccordion from './BodySpecialAccordion';
import BodySpecialAccordionHeader from './BodySpecialAccordionHeader';
import BodySpecialAccordionHeaderGroup from './BodySpecialAccordionHeaderGroup';
import BodySpecialAccordionContent from './BodySpecialAccordionContent';
import {dropdownOption} from '../../../shapes';

export const BodySpecialCardItem = ({accordion, children, config, disabled, dropdownOptions, className}) => {
	let render = [];
	for (const header of config) {
		if (!Array.isArray(header.render)) {
			render.push(header.render);
		} else {
			let group = [];
			for (const element of header.render) {
				group.push(element.render);
			}
			render.push(
				<BodySpecialAccordionHeaderGroup className={header.className} name={header.header}>
					{group}
				</BodySpecialAccordionHeaderGroup>
			);
		}
	}

	return (
		<BodySpecialAccordion
			className={`BodySpecialAccordion body-special-card-item ${className}`}
			onOpen={() => {
				return;
			}}
		>
			<BodySpecialAccordionHeader accordion={accordion && !disabled} dropdownOptions={dropdownOptions}>
				{render}
			</BodySpecialAccordionHeader>
			{children && (
				<BodySpecialAccordionContent className="body-special-accordion-content customScrollbar">
					{children}
				</BodySpecialAccordionContent>
			)}
		</BodySpecialAccordion>
	);
};

BodySpecialCardItem.propTypes = {
	className: PropTypes.string,
	accordion: PropTypes.bool,
	config: PropTypes.arrayOf(
		PropTypes.shape({
			render: PropTypes.oneOfType([
				PropTypes.node,
				PropTypes.arrayOf(
					PropTypes.shape({
						label: PropTypes.string,
						render: PropTypes.node
					})
				)
			]),
			label: PropTypes.string
		})
	).isRequired,
	disabled: PropTypes.bool,
	dropdownOptions: PropTypes.arrayOf(dropdownOption),
	children: PropTypes.node
};

BodySpecialCardItem.defaultProps = {
	className: 'BodySpecialAccordion body-special-card-item',
	accordion: true,
	disabled: false
};

export default BodySpecialCardItem;
